import { ExportSheet } from '../core';
import { DataPreparer } from '../factory';

export class ListagemCoresExportPreparer implements DataPreparer {
  async prepareForExport(selectedItems: any[]): Promise<ExportSheet[]> {
    const mainSheetData = selectedItems.map((item) => {
      return {
        id: item.id,
        codigoHexadecimal: item.codigoHexadecimal,
        nomeCor: item.nomeCor,
        observacoes: item.observacoes,
        usuarioRegistro: item.usuarioRegistro?.nomeCompleto || 'N/A',
        dataRegistro: item.dataRegistro,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao?.nomeCompleto || 'N/A',
        nEdicoes: item.nEdicoes || 0,
      };
    });

    const mainSheet: ExportSheet = {
      name: 'Listagem de Cores',
      columns: {
        id: 'ID',
        codigoHexadecimal: 'Código Hex',
        nomeCor: 'Nome da Cor',
        observacoes: 'Observações',
        usuarioRegistro: 'Responsável pelo Registro',
        dataRegistro: 'Data de Registro',
        dataUltimaAtualizacao: 'Última Atualização',
        usuarioAtualizacao: 'Responsável Ult. Atualização',
        nEdicoes: 'Edições',
      },
      data: mainSheetData,
    };

    return [mainSheet];
  }
}
